// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__181lV","colMaxWidth":"Table_colMaxWidth__2Q7tA"};